export enum ButtonFunction
{
	Help,
    GamesMenu,
    Spin,
    MaxBet,
	Autoplay,
}

export class AvailableButton
{
	protected buttonId:number;
	protected buttonFunction:ButtonFunction;
	protected lightId:number;

	public constructor(buttonId:number, buttonFunction:ButtonFunction, lightId:number)
	{
		this.buttonId = buttonId;
		this.buttonFunction = buttonFunction;
		this.lightId = lightId;
	}
	/* public Spin():AvailableButton[]
	{
		let buttons:AvailableButton[] = [];
		buttons.push(new AvailableButton(1, ButtonFunction.Help, 1));
		buttons.push(new AvailableButton(2, ButtonFunction.GamesMenu, 1));
		buttons.push(new AvailableButton(12, ButtonFunction.MaxBet, 14));
		buttons.push(new AvailableButton(13, ButtonFunction.Autoplay, 15));

		return buttons;
	} */

	public static FromJSON(json: any): AvailableButton {
		return new AvailableButton(json.ButtonId, json.ButtonFunction, json.LightId);
	}
}

export class PressButtons
{

    public Spin():AvailableButton[]
	{
		let buttons:AvailableButton[] = [];
        buttons.push(new AvailableButton(1, ButtonFunction.Help, 1));
        buttons.push(new AvailableButton(10, ButtonFunction.Spin, 12));
		buttons.push(new AvailableButton(2, ButtonFunction.GamesMenu, 2));
		buttons.push(new AvailableButton(12, ButtonFunction.MaxBet, 14));
		buttons.push(new AvailableButton(13, ButtonFunction.Autoplay, 15));

		return buttons;
    }
    
    public StopReel():AvailableButton[]
	{
		let buttons:AvailableButton[] = [];
        buttons.push(new AvailableButton(10, ButtonFunction.Spin, 12));

		return buttons;
    }
    
    public BigWin():AvailableButton[]
	{
		let buttons:AvailableButton[] = [];
        buttons.push(new AvailableButton(1, ButtonFunction.Help, 1));
        buttons.push(new AvailableButton(10, ButtonFunction.Spin, 12));
		buttons.push(new AvailableButton(2, ButtonFunction.GamesMenu, 2));
		buttons.push(new AvailableButton(12, ButtonFunction.MaxBet, 14));
		buttons.push(new AvailableButton(13, ButtonFunction.Autoplay, 15));

		return buttons;
    }

    public Collect():AvailableButton[]
    {
		let buttons:AvailableButton[] = [];
        buttons.push(new AvailableButton(10, ButtonFunction.Spin, 12));

		return buttons;
    }

}